import {UserForm}                   from './UserForm';
import {block, i18nProject}         from './block';
import                                  './styles/index.less';

export {
    UserForm,
    block,
    i18nProject,
}
